<template>
  <div id="checkout_personal_data_form" v-if="step == step_name">
    <step-header
      title="Dati personali"
      icon="user"
      :colour="colour"
      v-on="$listeners"
    ></step-header>
    <div class="bg-white rounded-b-lg">
      <div class="checkout-form content section-light transition">
        <div class="mx-auto mx-20">
          <div class="flex flex-wrap justify-around">
            <div class="p-4 w-full lg:w-1/2 justify-center">
              <linkem-datetime
                :errorModel="checkout_errors.birth_date"
                :value="personal_data.birth_date"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    birth_date: $event
                  })
                "
                modelName="checkout.personal_data.birth_date"
                label="Data Nascita"
                idName="birth_date"
              ></linkem-datetime>
            </div>
            <div class="p-4 w-full lg:w-1/2 justify-center">
              <input-autocomplete
                :errorModel="checkout_errors.sex"
                :value="personal_data.sex"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    sex: $event
                  })
                "
                modelName="checkout.personal_data.sex"
                label="Sesso"
                :options="sex"
              ></input-autocomplete>
            </div>
          </div>
          <div class="flex flex-wrap justify-around">
            <div class="p-4 w-full lg:w-1/2 justify-center">
              <input-autocomplete
                :errorModel="checkout_errors.birth_country"
                :value="personal_data.birth_country"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    birth_country: $event,
                    birth_city: null
                  });
                  checkEnable($event);
                "
                modelName="checkout.personal_data.birth_country"
                label="Paese di Nascita"
                enabled
                api="getnations"
              ></input-autocomplete>
            </div>
            <div class="p-4 w-full lg:w-1/2 justify-center">
              <input-autocomplete
                v-if="enabled"
                :errorModel="checkout_errors.birth_city"
                :value="personal_data.birth_city"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    birth_city: $event
                  })
                "
                modelName="checkout.personal_data.birth_city"
                label="Comune di Nascita"
                :enabled="enabled"
                api="getlocations"
              ></input-autocomplete>
            </div>
          </div>
          <div class="flex flex-wrap justify-around">
            <div class="p-4 w-full justify-center">
              <linkem-input
                :errorModel="checkout_errors.fiscal_code"
                :value="personal_data.fiscal_code"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    fiscal_code: $event
                  })
                "
                modelName="checkout.personal_data.fiscal_code"
                label="Codice fiscale"
                :maxLength="inputLength.taxCodeLength"
                autocompleteField="on"
              ></linkem-input>
            </div>
          </div>
          <div class="flex flex-wrap justify-around">
            <div class="p-4 w-full lg:w-1/2 justify-center">
              <linkem-input
                :errorModel="checkout_errors.document_number"
                :value="personal_data.document_number"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    document_number: $event
                  })
                "
                modelName="checkout.personal_data.document_number"
                label="Numero documento"
                :maxLength="inputLength.docNumberLength"
                autocompleteField="on"
              ></linkem-input>
              <!-- NUOVO: avviso se il tipo dichiarato è "carta d'identità elettronica"
                   ma il numero inserito non rispetta il formato CIE (2 lettere - 5 numeri - 2 lettere) -->
              <span
                v-if="documentNumberMismatch"
                class="text-xs text-error block mt-1"
              >
                Il numero inserito non sembra quello di una Carta d'Identità Elettronica
              </span>
              <!-- FINE NUOVO -->
            </div>
            <div class="p-4 w-full lg:w-1/2 justify-center">
              <input-autocomplete
                :errorModel="checkout_errors.document_type"
                :value="personal_data.document_type"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    document_type: $event
                  })
                "
                modelName="checkout.personal_data.document_type"
                label="Selezionare il tipo documento"
                :options="document_types"
              ></input-autocomplete>
            </div>
          </div>
          <div class="flex flex-wrap justify-around">
            <div class="p-4 w-full lg:w-1/2 justify-center">
              <linkem-datetime
                :errorModel="checkout_errors.released_at"
                :value="personal_data.released_at"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    released_at: $event
                  })
                "
                modelName="checkout.personal_data.released_at"
                label="Data Rilascio"
                idName="released_at"
              ></linkem-datetime>
            </div>
            <div class="p-4 w-full lg:w-1/2 justify-center">
              <linkem-input
                :errorModel="checkout_errors.released_by"
                :value="personal_data.released_by"
                @input="
                  $emit('update:personal_data', {
                    ...personal_data,
                    released_by: $event
                  })
                "
                modelName="checkout.personal_data.released_by"
                label="Rilasciato da"
                :maxLength="inputLength.docReleasedFromLength"
                autocompleteField="on"
              ></linkem-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    step: {
      type: String,
      required: true
    },
    personal_data: {
      required: true
    },
    checkout_errors: {
      required: true
    },
    inputLength: {
      required: true
    },
    colour: {
      default: "arancio"
    }
  },
  data: function() {
    return {
      step_name: "personal_data",
      sex: [
        { code: "F", label: "Femminile" },
        { code: "M", label: "Maschile" }
      ],
      document_types: [
        { code: "CartaDiIdentita", label: "Carta d'identità elettronica" },
        { code: "Passaporto", label: "Passaporto" },
        { code: "PatenteDiGuida", label: "Patente di guida" }
      ],
      enabled: false
    };
  },
  computed: {
    // NUOVO: true solo se il tipo documento selezionato è "CartaDiIdentita"
    // (qui l'unica opzione carta d'identità disponibile, dichiarata "elettronica")
    isCartaIdentitaSelected() {
      const docType = this.personal_data.document_type;
      const code = docType && docType.code ? docType.code : docType;
      return code === "CartaDiIdentita";
    },
    // NUOVO: true se il tipo è "CartaDiIdentita" ma il numero inserito
    // non rispetta il formato CIE (2 lettere - 5 numeri - 2 lettere)
    documentNumberMismatch() {
      if (!this.isCartaIdentitaSelected) return false;
      const number = (this.personal_data.document_number || "")
        .toUpperCase()
        .trim();
      if (!number) return false;
      return !/^[A-Z]{2}\d{5}[A-Z]{2}$/.test(number);
    }
  },
  methods: {
    checkEnable(birth_country) {
      this.enabled = birth_country.code == "ITALIA;Z000;IT";
      // this.$emit('update:personal_data', {
      //   ...this.personal_data,
      //   birth_city: null
      // })
      this.checkout_errors.birth_city = null;
    }
  }
};
</script>